import './FirebaseLists2.css';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectAuth } from '../../authNew/authSlice';
import { BasePageContainer, BaseCard, BaseVerticalContainer, BaseComponentContainer } from '../../../common/viewBaseComponents';
import { Card } from 'primereact/card';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Divider } from 'primereact/divider';

export default function FirebaseLists2({ path = '/movies/movies_db_movies.json'}) {
    const auth = useSelector(selectAuth);
    const [movies, setMovies] = useState([]);
    const [filteredMovies, setFilteredMovies] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');

    // Carica i dati dal file JSON
    useEffect(() => {
        fetch(path)
            .then(response => response.json())
            .then(data => {
                setMovies(data);
                setFilteredMovies(data);
            })
            .catch(error => {
                console.error('Errore nel caricamento dei dati:', error);
            });
    }, []);

    // Filtra i film in base al termine di ricerca
    useEffect(() => {

        if (searchTerm.trim() === '') {
            setFilteredMovies(movies);
        } else {

            if(searchTerm.length < 3)
                return;

            const term = searchTerm.toLowerCase();
            const filtered = movies.filter(movie =>
                movie.cleanTitle.toLowerCase().includes(term) ||
                movie.director.toLowerCase().includes(term) ||
                movie.genre.toLowerCase().includes(term) ||
                movie.plot.toLowerCase().includes(term) ||
                movie.filename.toLowerCase().includes(term) ||
                movie.rating.toLowerCase().includes(term) ||
                movie.actors.toLowerCase().includes(term) ||
                movie.nation.toLowerCase().includes(term) ||                
                movie.year.toLowerCase().includes(term)
            );
            setFilteredMovies(filtered);
        }
    }, [searchTerm, movies]);

    // Controllo autenticazione
    if (!auth.isLogged) {
        return (
            <BasePageContainer>
                <Card title="Accesso Negato">
                    <p>Devi essere autenticato per visualizzare questa pagina.</p>
                </Card>
            </BasePageContainer>
        );
    }

    return (
        <BasePageContainer className={'w-12 flipleft'}>
            <BaseComponentContainer>
            <BaseVerticalContainer>
            <Card title="Ricerca Film" className={'w-12'}>
                <div className="p-mb-3">
                    <InputText
                        id="search"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        placeholder="Cerca per titolo, regista, genere, trama, ecc."
                        className="p-d-block search-input-responsive"
                    />
                </div>              

                    {filteredMovies.length > 0 ? (
                        filteredMovies.map((movie, index) => (
                            <BaseCard key={index} className="p-p-3">
                                <div className="p-d-flex p-flex-column">

                                    <div className="p-mb-2" style={{ fontSize: '2rem' }}>
                                        <strong>{movie.cleanTitle}</strong>
                                    </div>                                   
                                    <div className="p-mb-2 p-1">
                                        <strong>Genere:</strong> {movie.genre}
                                    </div>
                                    <div className="p-mb-2 p-1">
                                        <strong>Regista:</strong> {movie.director}
                                    </div>
                                    <div className="p-mb-2 p-1">
                                        <strong>Valutazione:</strong> {movie.rating}
                                    </div>
                                    <div className="p-mb-2 p-1">
                                        <strong>Trama:</strong> {movie.plot}
                                    </div>                                                                       
                                    
                                    <div className="p-mb-2 p-1">
                                        <strong>Attori:</strong> {movie.actors}
                                    </div>
                                    <div className="p-mb-2 p-1">
                                        <strong>Nazione:</strong> {movie.nation}
                                    </div>
                                    <div className="p-mb-2 p-1">
                                        <strong>Anno:</strong> {movie.year}
                                    </div>
                                    <div className="p-mb-2 p-1">
                                        <strong>Sorgente:</strong> {movie.sourceFile}
                                    </div>
                                     <div className="p-mb-2 p-1"  style={{ fontSize: '0.9rem' }}>
                                        <strong>Nome file:</strong> {movie.filename.replaceAll('.','  ')}
                                    </div>
                                    <div className="p-mb-2 p-1"  style={{ fontSize: '0.9rem' }}>
                                        <strong>Percorso:</strong> {movie.path.replaceAll('.','  ')}
                                    </div>
                                </div>
                            </BaseCard>
                        ))
                    ) : (
                        <Card>
                            <p>Nessun film trovato.</p>
                        </Card>
                    )}
            </Card>
            </BaseVerticalContainer>
            </BaseComponentContainer>
        </BasePageContainer>
    );
}